import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trackWaitlistView } from "@/lib/analytics";
import { COPY } from "@/content/copy";

const CTASection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackWaitlistView('cta');
  }, []);

  return (
    <section className="py-20 px-4 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-primary/[0.02]" aria-hidden="true"></div>
      <div className="relative max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-heading font-semibold mb-6 text-primary">
          {COPY.closing.title}
        </h2>
        <p className="text-xl text-foreground/80 font-body mb-12 max-w-2xl mx-auto leading-relaxed">
          {COPY.closing.description}
        </p>
        
        <Button
          size="lg"
          className="font-medium"
          onClick={() => navigate("/travel")}
        >
          Search Travel Now
        </Button>
        
        <p className="text-sm text-muted-foreground mt-6 font-body">
          Start exploring — it's free to compare.
        </p>
        
        <div className="mt-4">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-xs"
          >
            Back to Top
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
